import React from 'react';
import { eventDispatcher, TOPICS } from '@origin-digital/event-dispatcher';

import { destroyLiveChat } from 'ts/services/liveChatService';
import { useAppContext } from '../contexts/app/AppContext';

export const LiveChat: React.FC<{}> = ({}) => {
  const { showLiveChatWidget } = useAppContext();

  React.useEffect(() => {
    showLiveChat();
    return () => {
      if (showLiveChatWidget === false) {
        hideLiveChat();
      }
    };
  }, []);
  return null;
};

const showLiveChat = () => {
  eventDispatcher.dispatch({
    payload: {},
    topic: TOPICS.CHAT_INIT,
  });
};

const hideLiveChat = () => {
  destroyLiveChat();
};
